/**
 * Storage version-based migration. When this constant is bumped on a deploy,
 * the frontend boot code in `index.js` detects the mismatch and wipes any
 * client-side cache that depends on the column / preset schema (tablecols:*,
 * legacy migration flags, etc.). Users get the new defaults without manually
 * clearing DevTools storage.
 *
 * Bump this string on every deploy that changes:
 *   - Default column widths / labels in any module
 *   - tablecols:* serialization format
 *   - User preset schema
 */
export const STORAGE_VERSION = "iter301";
export const STORAGE_VERSION_KEY = "__solar_green_storage_version__";

/**
 * Run on app boot. Detects version mismatch and clears stale UI cache while
 * leaving auth tokens, user preferences and language alone.
 */
export function runStorageMigration() {
  try {
    const saved = localStorage.getItem(STORAGE_VERSION_KEY);
    if (saved === STORAGE_VERSION) return;
    // Wipe known UI-state keys
    const KEYS_TO_WIPE_PREFIX = ["tablecols:", "presets:", "filters:"];
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && KEYS_TO_WIPE_PREFIX.some(p => k.startsWith(p))) toRemove.push(k);
    }
    toRemove.forEach(k => localStorage.removeItem(k));
    localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);
    if (saved && toRemove.length) {
      // Soft log so devs know migration ran (no toast — silent for users)
      // eslint-disable-next-line no-console
      console.info(`[storage-migrate] ${saved} → ${STORAGE_VERSION} (cleared ${toRemove.length} keys)`);
    }
  } catch {/* localStorage may be disabled in private mode — ignore */}
}
